(() => {
const $7cfa924ff7d1afa0$var$selectors = {
    container: '.group-cuddle',
    item: '.group-cuddle__item'
};
const $7cfa924ff7d1afa0$var$classNames = {
    active: 'group-cuddle__item--active'
};
document.querySelectorAll($7cfa924ff7d1afa0$var$selectors.container).forEach((group)=>{
    const items = group.querySelectorAll($7cfa924ff7d1afa0$var$selectors.item);
    const handleItem = (e)=>{
        const item = e.currentTarget;
        const itemIsActive = item.classList.contains($7cfa924ff7d1afa0$var$classNames.active);
        items.forEach((item)=>item.classList.remove($7cfa924ff7d1afa0$var$classNames.active));
        !itemIsActive && item.classList.add($7cfa924ff7d1afa0$var$classNames.active);
    };
    items.forEach((item)=>{
        item.addEventListener('click', handleItem);
    });
});

})();
//# sourceMappingURL=group_cuddle.min.js.map
